import { Injectable } from '@angular/core';
import { HelperService } from '../shared/services/helper.service';
import { environment } from 'src/environments/environment';
import { HttpService } from '../shared/services/http.service';

@Injectable()
export class JobService {

    private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
    private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
    private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
    private URL: string;
    
    constructor(private httpService: HttpService) { }

    public CreateGiftCardJobActivation(params){
        this.URL = `${this.REQUEST_URL}/createGiftCardJobActivation`;
        return this.httpService.post<any>(this.URL, params);
    }

    public UpdateGiftCardJobActivation(params){
        this.URL = `${this.REQUEST_URL}/updateGiftCardJobActivation`;
        return this.httpService.put<any>(this.URL, params);
    }
}